// گیرندگان وجه
import React from 'react';
import { ui } from '../../components/ListPage';
import JalaliDatePicker from '../../components/JalaliDatePicker';
import CrudView from './CrudView';
import { Field, TextInput, Lookup, basicApi } from './basicShared';

const COLS = [
  { key: 'person_kind_title', label: 'نوع شخص' }, { key: 'class_title', label: 'جزءطبقه' },
  { key: 'active_title', label: 'فعال/غیرفعال' }, { key: 'receiver', label: 'گیرنده وجه' },
  { key: 'father_name', label: 'نام پدر' }, { key: 'gender_title', label: 'جنسیت' }, { key: 'bank', label: 'بانک' },
  { key: 'account_no', label: 'حساب', ltr: true }, { key: 'sheba_error', label: 'خطای حساب شبا' },
  { key: 'id_no', label: 'شناسه ملی', ltr: true }, { key: 'virtual_code', label: 'کد' }, { key: 'remark', label: 'صاحب حساب' },
  { key: 'economy_code', label: 'کد اقتصادی', ltr: true }, { key: 'pay_id', label: 'شناسه پرداخت', ltr: true },
  { key: 'exchange_code', label: 'کد بورس', ltr: true }, { key: 'account_no_for_amount', label: 'حساب اسناد خزانه', ltr: true },
  { key: 'exchange_code_for_interest', label: 'کد بورس برای حفظ قدرت خرید', ltr: true },
  { key: 'account_no_for_interest', label: 'حساب سود اسناد خزانه', ltr: true },
  { key: 'register_date', label: 'تاریخ تولد/ثبت' }, { key: 'register_no', label: 'شماره شناسنامه/ثبت' },
  { key: 'tel_no', label: 'تلفن', ltr: true }, { key: 'city', label: 'محل تولد/ثبت' },
];

const EMPTY = {
  virtual_code: '', receiver: '', father_name: '', gender: 0, person_kind: 0, class_code: 0, is_active: true,
  account_no: '', branch_code: 0, bank: '', remark: '', id_no: '', economy_code: '', pay_id: '',
  exchange_code: '', account_no_for_amount: '', exchange_code_for_interest: '', account_no_for_interest: '',
  register_date: '', register_no: '', tel_no: '', city_id: 0, city: '',
};

// همان قاعدهٔ اعتبار شبا در سرور
export function checkSheba(v) {
  let s = String(v || '').trim().replace(/ /g, '');
  if (s.length < 24 || s.length > 26 || s.length === 25) return false;
  if (s.slice(0, 2).toUpperCase() !== 'IR') s = 'IR' + s;
  if (s.length !== 26 || !/^\d+$/.test(s.slice(2))) return false;
  return BigInt(s.slice(4) + '1827' + s.slice(2, 4)) % BigInt(97) === BigInt(1);
}

function Fields({ f, set, setMany, meta }) {
  const kinds = meta.person_kinds || [];
  const classes = meta.class_codes || [];
  const legal = Number(f.person_kind) < 5;
  const badSheba = f.account_no && !checkSheba(f.account_no);
  return (
    <>
      <div style={ui.row}>
        <Field label="کد" width="100px"><TextInput value={f.virtual_code} onChange={v => set('virtual_code', v)} ltr autoFocus /></Field>
        <Field label="گیرنده وجه"><TextInput value={f.receiver} onChange={v => set('receiver', v)} /></Field>
        <Field label="نوع شخص" width="200px">
          <select value={f.person_kind} onChange={e => set('person_kind', Number(e.target.value))} style={ui.input}>
            {kinds.map((k, i) => <option key={i} value={i}>{k}</option>)}
          </select>
        </Field>
        <label style={{ display: 'flex', alignItems: 'center', gap: '4px', fontSize: '13px', alignSelf: 'flex-end' }}>
          <input type="checkbox" checked={!!f.is_active} onChange={e => set('is_active', e.target.checked)} />فعال
        </label>
      </div>
      <div style={ui.row}>
        <Field label="نام پدر"><TextInput value={legal ? '' : f.father_name} readOnly={legal} onChange={v => set('father_name', v)} /></Field>
        <Field label="جنسیت" width="110px">
          <select value={legal ? 2 : f.gender} disabled={legal} onChange={e => set('gender', Number(e.target.value))} style={ui.input}>
            <option value={0}>مرد</option><option value={1}>زن</option><option value={2}>---</option>
          </select>
        </Field>
        <Field label={[5, 6].includes(Number(f.person_kind)) ? 'کد ملی' : 'شناسه ملی'} width="160px">
          <TextInput value={f.id_no} onChange={v => set('id_no', v)} ltr />
        </Field>
        <Field label="کد اقتصادی" width="150px"><TextInput value={f.economy_code} onChange={v => set('economy_code', v)} ltr /></Field>
      </div>
      <div style={ui.row}>
        <Field label="کد طبقه">
          <select value={f.class_code} onChange={e => set('class_code', Number(e.target.value))} style={ui.input}>
            {classes.map((k, i) => <option key={i} value={i}>{k}</option>)}
          </select>
        </Field>
      </div>
      <div style={ui.row}>
        <Field label="حساب"><TextInput value={f.account_no} onChange={v => set('account_no', v)} ltr /></Field>
        <Lookup label="بانک" text={f.bank} endpoint="/amount-receivers/lookup/branch/"
          onPick={r => setMany({ branch_code: r.id, bank: r.title || '' })} />
        <Field label="شناسه پرداخت فارغ از مبلغ" width="170px"><TextInput value={f.pay_id} onChange={v => set('pay_id', v)} ltr /></Field>
      </div>
      {badSheba && <div style={{ ...ui.errBox, marginTop: '-6px' }}>شماره حساب شبا اشتباه است</div>}
      <div style={ui.row}>
        <Field label="صاحب حساب"><TextInput value={f.remark} onChange={v => set('remark', v)} /></Field>
      </div>
      <fieldset style={{ border: '1px solid #e0e0e0', borderRadius: '8px', padding: '8px 12px', marginBottom: '12px' }}>
        <legend style={{ fontSize: '12px', color: '#1a2f50', fontWeight: 700 }}>اسناد خزانه</legend>
        <div style={ui.row}>
          <Field label="اصل مبلغ دریافتی: حساب"><TextInput value={f.account_no_for_amount} onChange={v => set('account_no_for_amount', v)} ltr /></Field>
          <Field label="کد بورس" width="150px"><TextInput value={f.exchange_code} onChange={v => set('exchange_code', v)} ltr /></Field>
        </div>
        <div style={ui.row}>
          <Field label="حفظ قدرت خرید: حساب"><TextInput value={f.account_no_for_interest} onChange={v => set('account_no_for_interest', v)} ltr /></Field>
          <Field label="کد بورس" width="150px"><TextInput value={f.exchange_code_for_interest} onChange={v => set('exchange_code_for_interest', v)} ltr /></Field>
        </div>
      </fieldset>
      <div style={ui.row}>
        <Field label="تاریخ تولد/ثبت" width="160px"><JalaliDatePicker value={f.register_date} onChange={v => set('register_date', v)} /></Field>
        <Field label="شماره شناسنامه/ثبت" width="150px"><TextInput value={f.register_no} onChange={v => set('register_no', v)} ltr /></Field>
        <Lookup label="محل تولد/ثبت/شهر" text={f.city} endpoint="/amount-receivers/lookup/city/"
          onPick={r => setMany({ city_id: r.id, city: r.title || '' })} />
        <Field label="تلفن" width="140px"><TextInput value={f.tel_no} onChange={v => set('tel_no', v)} ltr /></Field>
      </div>
    </>
  );
}

// انتخاب ردیف: پیشنهاد محاسبهٔ شبا از شناسهٔ شبای بانک شعبه
function onRowSelected(r, { api, reload, setAsk, setMsg, fb }) {
  const acc = String(r.account_no || '').trim();
  if (!fb.can('BTNEDIT') || !r.branch_code || !r.sheba_id || ![12, 13].includes(acc.length)) return;
  setAsk({ title: 'هشدار', lines: ['شماره حساب شبا محاسبه شود؟'], yesLabel: 'بلی', noLabel: 'خیر',
    no: () => setAsk(null),
    yes: async () => {
      setAsk(null);
      const j = await api(`/amount-receivers/${r.id}/sheba/`, { method: 'POST', body: '{}' });
      if (j.ok) reload(); else if (j.msg) setMsg([j.msg]);
    } });
}

export default function AmountReceivers({ user, onBack }) {
  return (
    <CrudView user={user} onBack={onBack} form="FRMAMOUNTRECEIVERS" title="گیرندگان وجه" unit="گیرنده"
      path="/amount-receivers" cols={COLS} empty={EMPTY} modalWidth={860} renderFields={Fields}
      newForm={async () => {
        const j = await basicApi('/amount-receivers/next-code/');
        return { ...EMPTY, virtual_code: j.ok ? String(j.code) : '' };
      }}
      toForm={r => ({ ...EMPTY, ...r })} onRowSelected={onRowSelected} changeBtn="BTNCHANGEID" />
  );
}
